import "../../challenges/Challenges.css"
import React, { useState } from "react";
import "../../myProjects/Myprojects.css"
import { FileUploader } from 'react-drag-drop-files';
import api from "views/auth/Api";
import { message } from 'antd';
import { API_BASE_URL } from '../../../../configs/AppConfig';
import { FILES_URL } from '../../../../configs/AppConfig';
import {modelAdded} from "../../tables/variables/columnsData";
import ModelsTable from "../../tables/components/ModelsTable";
import Loader from "components/loader";
import { IoCheckmarkDoneCircleSharp } from "react-icons/io5";



const fileTypes = ["JPG", "PNG", "WEBP","JPEG"];
const gcodeTypes = ["GCODE"];
const MAX_SIZE = 10 * 1024 * 1024; // 10MB
const MAX_GCODE_SIZE = 50 * 1024 * 1024; // 50MB


const Add3dModel = () => {
  const [img, setImg] = useState(null);
  const [modelImg, setModelImg] = useState(null);
  const [gcode, setGcode] = useState(null);
  const [modelId, setModelId] = useState(null);
  const [cardLoading, setCardLoading] = useState(false);
  const [imagesLoading, setImagesLoading] = useState(false);
  const [gcodeLoading, setGcodeLoading] = useState(false);
  const [tableData , setTableData] = useState([]); 

        const [formInputs , setFormInputs] = useState({
          libraryName:"",
          modelName:"",
          buildPlates:"",
          partsWeight:"",
          recommendMaterial:"",
          averagePrint:"",
          partsQuantity:"",
        });
    
      const success = () => {
           message.success('Your 3D Model careated successfully');
          };

    const successPhoto = () => {
           message.success('Your Image uploaded successfully');
          };
    const successGcode = () => {
           message.success('Your Gcode uploaded successfully');
          };

     const successSaved = () => {
           message.success('Your 3D Model created Completely');
          };
      const sizeMessage = () => {
           message.error('File size exceeds the limit of 10MB');
          }
          const sizeGMessage = () => {
           message.error('File size exceeds the limit of 50MB');
          }


        const isPublishValid = formInputs.libraryName.trim() !== '' && img !== null
        const isFormValid =
         formInputs.modelName.trim() !== '' &&
          formInputs.buildPlates.trim() !== '' &&
           formInputs.partsWeight !== '' &&
            formInputs.recommendMaterial.trim() !== '' &&
             formInputs.averagePrint.trim() !== '' &&
              formInputs.partsQuantity !== '' && modelImg !== null;
        // const isImageValid = modelImg !== null
        
        const handleImgChange = async (img) => {
          setCardLoading(true);
            if (img.size > MAX_SIZE) {
          sizeMessage();
          return;
          }
          const formData = new FormData();
          formData.append('img', img);
          console.log('Uploaded file:', img);
           await api.post(`${API_BASE_URL}attachment`,formData, {
                      headers: {
            'Content-Type': 'multipart/form-data',
          },
                    })
                            .then(function (response) {
                                setCardLoading(false);
                                  successPhoto();
                                  setImg(response.data);
                            }).catch(error => {
                              console.log("handlesubmit error for blog get ", error)
                            });
        };

      const handleCoverChange = async (modelImg) => {
          setImagesLoading(true);
          if (modelImg.size > MAX_SIZE) {
          sizeMessage();
          return;
          }
        const formData = new FormData();
          formData.append('img', modelImg);
          console.log('Uploaded file:', modelImg);
           await api.post(`${API_BASE_URL}attachment`,formData, {
                      headers: {
            'Content-Type': 'multipart/form-data',
          },
                    })
                            .then(function (response) {
                              setImagesLoading(false);
                                  successPhoto();
                                    setModelImg(response.data);
                                  // setData(response.data)
                            }).catch(error => {
                              console.log("handlesubmit error for blog get ", error)
                            });
        };
    const handleGcodeChange = async (gcode) => {
          setGcodeLoading(true);
          if (gcode.size > MAX_GCODE_SIZE) {
          sizeGMessage();
          return;
          }
              const formData = new FormData();
              formData.append('gcode', gcode);
              console.log('Uploaded file:', gcode);
               await api.post(`${API_BASE_URL}attachment/gcode`,formData, {
                          headers: {
                'Content-Type': 'multipart/form-data',
              },
                        })
                                .then(function (response) {
                                      setGcodeLoading(false);
                                      successGcode();
                                      setGcode(response.data);
                                }).catch(error => {
                                  console.log("handlesubmit error for blog get ", error)
                                });
            };
    

    const handleAddPlate = (event) => {
    event.preventDefault();
      addPlate();
      setFormInputs({
          libraryName:"",
          modelName:"",
          buildPlates:"",
          partsWeight:"",
          recommendMaterial:"",
          averagePrint:"",
          partsQuantity:"",
        })
        setModelImg(null);
        setGcode(null);
        // setImg(null);
    }

    const handlePublish = async (event) => {  
          event.preventDefault();
       await api.post(`${API_BASE_URL}projects-3dmodel`,{
          libraryName: formInputs.libraryName,
          img: img? img.id : null,
          })
        .then(function (response) {
                  console.log("handlesubmitffff  ", response.data)
                  success();
                  setModelId(response.data)
              // setData(response.data)
        }).catch(error => {
          console.log("handlesubmit error for blog get ", error)
        });   
          }

      const addPlate = async () => {  
       await api.post(`${API_BASE_URL}parts-3dmodel`,{
          modelName: formInputs.modelName,
          buildPlates: formInputs.buildPlates,
          partsWeight: formInputs.partsWeight,
          recommendMaterial: formInputs.recommendMaterial,
          averagePrint: formInputs.averagePrint,
          partsQuantity: formInputs.partsQuantity,
          modelId: modelId.id,
          modelImg: modelImg? modelImg.id : null,
          gcode: gcode? gcode.id : null,
          })
        .then(function (response) {
                  console.log("handlesubmitffff  ", response.data)
                  success();
                  setTableData(response.data);
              // setData(response.data)
        }).catch(error => {
          console.log("handlesubmit error for blog get ", error)
        });   
          }

      const handleSave = () => {
        successSaved();
          setFormInputs({
          libraryName:"",
          modelName:"",
          buildPlates:"",
          partsWeight:"",
          recommendMaterial:"",
          averagePrint:"",
          partsQuantity:"",
        })
        setImg(null);
        setModelImg(null);
        setModelId(null);
        setTableData([]);
        // setModelImages([]);
          }
    

  return (
    <div className="h-fit w-full pt-10">
    {!modelId ? <h2 className="addLibrary-h2">Add New 3D Model</h2> : null}
    {modelId ? <h2 className="addLibrary-h2">Add Plates for {modelId.modelName}</h2> : null}
 
         {tableData[0] ?  <div className="model3d-container"> 
                <div className="model3d-cards-add" >
                   {tableData.map(img =>
                              <div className="model3d-card-add p-1" style={{backgroundImage:`url(${FILES_URL}${img.img?.url})`}}>
                              {/* <MdOutlineDeleteForever className="editIcons ml-auto" onClick={()=> {delImg(img.id)}}/> */}
                              </div>
                           )}
                </div> 
          </div>
          : null}

     <ModelsTable
          columnsData={modelAdded}
          tableData={tableData}
        />
   <form className="addChallenge mb-[100px]">          
    <div className="addChallengeFlex">
      <div className="addChallengeLR">
        {!modelId ?  <div className="addCHInpts">
            {/* <span>Challenge title</span> */}
            <label for="libraryName">Library Name</label>
            <input type="text" className="inputWidth" id="libraryName" value={formInputs.libraryName} placeholder="Enter library Name" 
            onChange={(e) =>setFormInputs({...formInputs, libraryName: e.target.value})}/>
          </div> : null}
            {modelId ?  <div className="addCHInpts">
            <label for="modelName">Model Name</label>
            <input type="text" className="inputWidth" id="modelName" value={formInputs.modelName} placeholder="Enter modelName"
             onChange={(e) =>setFormInputs({...formInputs, modelName: e.target.value})}/>
           </div> : null}
           {modelId ?  <div className="addCHInpts">
            <label for="partsQuantity">Parts Quantity</label>
            <input type="number"
            className="inputWidth" id="partsQuantity" value={formInputs.partsQuantity} placeholder="Enter Parts Quantity"
            onKeyDown={(e) => {
                if (["e", "E", "+", "-"].includes(e.key)) {
                  e.preventDefault();
                }}}
             onChange={(e) =>setFormInputs({...formInputs, partsQuantity: e.target.value})}/>
           </div> : null}
           {modelId ?  <div className="addCHInpts">
            <label for="averagePrint">Average Print</label>
            <input type="text" className="inputWidth" id="averagePrint" value={formInputs.averagePrint} placeholder="Enter averagePrint" 
            onChange={(e) =>setFormInputs({...formInputs, averagePrint: e.target.value})}/>
          </div> : null}
            {modelId ?  <div>
       <h4 className="trAttachment"> GCODE </h4>
        <div className="trAttachmentDev mrAtt flex">
        <FileUploader handleChange={handleGcodeChange} name="file" types={gcodeTypes} />
          <Loader loading={gcodeLoading} />
          {gcode && !gcodeLoading ? <IoCheckmarkDoneCircleSharp style={{ width: '45px', height: '45px', marginLeft: '10px', color: 'green' }}/> : null}
        </div>
          </div> : null}

        </div>

          <div className="addChallengeLR">
        {!modelId ?   <div>
        <h4 className="trAttachment"> Card Image </h4>
        <div className=" mrAtt">
        <FileUploader handleChange={handleImgChange} name="file" types={fileTypes} />
        <Loader loading={cardLoading} />
           {img && !cardLoading ? <img src={`${FILES_URL}${img.url}`} alt="" style={{ width: '150px', height: '130px', marginTop: '10px',borderRadius: '4px' }}/> : null}
        </div>
        </div> : null}

          {modelId ?  <div className="addCHInpts">
            <label for="buildPlates">Build Plates</label>
            <input type="text" className="inputWidth" id="buildPlates" value={formInputs.buildPlates} placeholder="Enter build plates"
             onChange={(e) =>setFormInputs({...formInputs, buildPlates: e.target.value})}/>
           </div> : null}

           {modelId ?  <div className="addCHInpts">
            <label for="partsWeight">Parts Weight</label>
            <input type="number" className="inputWidth" id="partsWeight" value={formInputs.partsWeight} placeholder="Enter partsWeight"
              onKeyDown={(e) => {
                if (["e", "E", "+", "-"].includes(e.key)) {
                  e.preventDefault();
                }}}
             onChange={(e) =>setFormInputs({...formInputs, partsWeight: e.target.value})}/>
          </div> : null}
          {modelId ?  <div className="addCHInpts">
            <label for="recommendMaterial">Recommend Material</label>
            <input type="text" className="inputWidth" id="recommendMaterial" value={formInputs.recommendMaterial} placeholder="Enter recommendMaterial" 
            onChange={(e) =>setFormInputs({...formInputs, recommendMaterial: e.target.value})}/>
          </div> : null}
          {modelId ?
          <div>
       <h4 className="trAttachment"> Part Image </h4>
       <div className="flex gap-x-4 "> 
        <div className="flex">
        <FileUploader handleChange={handleCoverChange} name="file" types={fileTypes} />
        <Loader loading={imagesLoading} />
     {modelImg && !imagesLoading ? <img src={`${FILES_URL}${modelImg.url}`} alt="" style={{ width: '150px', height: '140px', marginLeft: '20px', borderRadius: '4px',marginTop: '-30px' }}/> : null}
        </div>
              {/* {modelId ?  <button onClick={handleAddImg} disabled={!isImageValid} className="add-plate w-[110px]">Add Image</button> : null}  */}
              </div>
    </div>  
    : null}
     </div>

        </div>
        <div className="flex justify-center gap-x-4 mt-[25px]">
      {modelId ?  <button onClick={handleAddPlate} disabled={!isFormValid} className="add-plate w-[100px] mt-[25px]">Add Plate</button> : null}
      {modelId ?  <button onClick={handleSave} className="add-plate w-[100px] mt-[25px]">Save</button> : null}
        {!modelId ?  <button onClick={handlePublish} disabled={!isPublishValid} className="add-Challenge">Publish</button> : null}
        </div>
       </form> 
    </div>
  );
};

export default Add3dModel;
